// import clone from 'clone'
// import { initialState } from '../index'
import { PAYMENT_INIT_LOADING, PAYMENT_INIT_SUCCESS, PAYMENT_INIT_FAIL, PAYMENT_LOAD_DATA } from '@/store/types'

export const init = {
  [PAYMENT_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [PAYMENT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [PAYMENT_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [PAYMENT_LOAD_DATA] (state, data) {
    state.paymentData.branch = data.branch
    state.paymentData.accountNo = data.accountNo
    state.paymentData.type = data.type
    state.paymentData.documentNo = data.documentNo
    state.paymentData.fund = data.fund
    state.paymentData.suffix = data.suffix
    state.paymentData.tranMode = data.tranMode
  }
}
